<div *ngIf="admin">
  <clr-datagrid *ngIf="customerSettings" #grid class="customer-settings-list" [clrDgLoading]="loading">

    <clr-dg-action-bar>
      <div class="btn-group">
        <button type="button" class="btn btn-sm btn-secondary" (click)="addCustomerSetting()">
          <clr-icon shape="plus"></clr-icon> Add
        </button>
      </div>
    </clr-dg-action-bar>

    <clr-dg-column [clrDgField]="'name'">
      <ng-container *clrDgHideableColumn="{hidden: false}">Name</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'key'">
      <ng-container *clrDgHideableColumn="{hidden: true}">Key</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'valueNumeric'">
      <ng-container *clrDgHideableColumn="{hidden: true}">Value</ng-container>
    </clr-dg-column>
    <!-- <clr-dg-column [clrDgField]="'settingsType'">
      <ng-container *clrDgHideableColumn="{hidden: false}">Type</ng-container>
    </clr-dg-column> -->
    <clr-dg-column [clrDgField]="'valueType'">
      <ng-container *clrDgHideableColumn="{hidden: false}">ValueType</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'nodeId'">
      <ng-container *clrDgHideableColumn="{hidden: true}">NodeId</ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'nodeTypeId'">
      <ng-container *clrDgHideableColumn="{hidden: true}">NodeTypeId</ng-container>
    </clr-dg-column>

    <clr-dg-row *clrDgItems="let item of customerSettings ; index as i" [clrDgItem]="item">
      <clr-dg-cell> {{item.name + (item.hidden ? ' (hidden)' : '')}}</clr-dg-cell>
      <clr-dg-cell> {{item.key}}</clr-dg-cell>
      <clr-dg-cell *ngIf="item.valueType == CustomerSettingsValueType.NUMERIC"> {{item.valueNumeric}}</clr-dg-cell>
      <clr-dg-cell *ngIf="item.valueType == CustomerSettingsValueType.STRING"> {{item.valueString}}</clr-dg-cell>
      <clr-dg-cell *ngIf="item.valueType == CustomerSettingsValueType.TIMESTAMP"> {{item.valueTimestamp}}</clr-dg-cell>
      <!-- <clr-dg-cell> {{CustomerSettingType[item.settingsType]}}</clr-dg-cell> -->
      <clr-dg-cell> {{CustomerSettingsValueType[item.valueType]}}</clr-dg-cell>
      <clr-dg-cell> {{item.nodeId}}</clr-dg-cell>
      <clr-dg-cell> {{item.nodeTypeId}}</clr-dg-cell>
      <clr-dg-row-detail *clrIfExpanded>
        <div class="clr-rows edit-area">
          <div class="clr-row">
            <form clrForm clrLayout="vertical" autocomplete="off">
              <div class="clr-row">
                <div class="clr-col-6">
                  <clr-input-container>
                    <label class="clr-col-12">Name:</label>
                    <input clrInput class="clr-col-12" required placeholder="" size="30"
                      name="customersettingname" type="text" [(ngModel)]="item.name" />
                  </clr-input-container>
                  <clr-select-container>
                    <label class="clr-col-12">Key:</label>
                    <select clrSelect class="clr-col-12" name="customersettingskey" [(ngModel)]="item.key">
                      <option *ngFor="let keyItem of customerSettingsKeys" [ngValue]="keyItem.key">{{keyItem.name}}</option>
                    </select>
                  </clr-select-container>
                  <clr-select-container>
                    <label class="clr-col-12">Value type:</label>
                    <select clrSelect class="clr-col-12" name="customersettingvaluetype" [(ngModel)]="item.valueType">
                      <option [ngValue]="CustomerSettingsValueType.NUMERIC">Numeric</option>
                      <option [ngValue]="CustomerSettingsValueType.STRING">String</option>
                      <option [ngValue]="CustomerSettingsValueType.TIMESTAMP">Timestamp</option>
                    </select>
                  </clr-select-container>
                  <clr-input-container *ngIf="item.valueType == CustomerSettingsValueType.NUMERIC">
                    <label class="clr-col-12">Value:</label>
                    <input clrInput class="clr-col-12" placeholder="" max="999999999"
                      name="customersettingvaluenumeric" type="number" [(ngModel)]="item.valueNumeric" />
                  </clr-input-container>
                  <clr-input-container *ngIf="item.valueType == CustomerSettingsValueType.STRING">
                    <label class="clr-col-12">Value:</label>
                    <input clrInput class="clr-col-12" placeholder="" size="30"
                      name="customersettingvaluestring" type="text" [(ngModel)]="item.valueString" />
                  </clr-input-container>
                  <clr-input-container *ngIf="item.valueType == CustomerSettingsValueType.TIMESTAMP">
                    <label class="clr-col-12">Value:</label>
                    <input clrInput class="clr-col-12" placeholder="" size="40"
                      name="customersettingvaluetimestamp" type="date" [(ngModel)]="item.valueTimestamp" />
                  </clr-input-container>
                  <clr-input-container *ngIf="item.valueType == CustomerSettingsValueType.NUMERIC">
                    <label class="clr-col-12">Default value:</label>
                    <input clrInput class="clr-col-12" placeholder="" max="999999999"
                      name="customersettingvaluenumericdefault" type="number" [(ngModel)]="item.valueNumericDefault" />
                  </clr-input-container>
                  <clr-input-container *ngIf="item.valueType == CustomerSettingsValueType.STRING">
                    <label class="clr-col-12">Default value:</label>
                    <input clrInput class="clr-col-12" placeholder="" size="30"
                      name="customersettingvaluestringdefault" type="text" [(ngModel)]="item.valueStringDefault" />
                  </clr-input-container>
                  <clr-input-container *ngIf="item.valueType == CustomerSettingsValueType.TIMESTAMP">
                    <label class="clr-col-12">Default value:</label>
                    <input clrInput class="clr-col-12" placeholder="" size="40"
                      name="customersettingvaluetimestampdefault" type="date" [(ngModel)]="item.valueTimestampDefault" />
                  </clr-input-container>
                </div>
                <div class="clr-col-6" *ngIf="!nodeId || nodeId.length == 0">
                  <!-- <clr-select-container>
                    <label class="clr-col-12">Type:</label>
                    <select clrSelect class="clr-col-12" name="customersettingsType" [(ngModel)]="item.settingsType">
                      <option [ngValue]="CustomerSettingType.COMMON">Common</option>
                      <option [ngValue]="CustomerSettingType.SYSTEM">System</option>
                    </select>
                  </clr-select-container> -->
                  <clr-textarea-container *ngIf="!nodeId || nodeId.length == 0">
                    <label class="clr-col-12">Description</label>
                    <textarea clrTextarea class="clr-col-12" name="customersettingdescription"
                      [rows]="4" [cols]="50" [(ngModel)]="item.description"></textarea>
                  </clr-textarea-container>
                  <clr-input-container *ngIf="!nodeId || nodeId.length == 0">
                    <label class="clr-col-12">NodeId:</label>
                    <input clrInput class="clr-col-12" placeholder="" size="30" [disabled]="nodeId?.length > 0"
                      name="customersettingnodeid" type="text" [(ngModel)]="item.nodeId" />
                  </clr-input-container>
                  <clr-input-container *ngIf="!nodeId || nodeId.length == 0">
                    <label class="clr-col-12">NodeTypeId:</label>
                    <input clrInput class="clr-col-12" placeholder="" size="30" [disabled]="nodeTypeId?.length > 0"
                      name="customersettingnodetypeid" type="text" [(ngModel)]="item.nodeTypeId" />
                  </clr-input-container>
                </div>
                <div class="clr-col-6" *ngIf="nodeId?.length > 0">
                  <clr-textarea-container>
                    <label class="clr-col-12">Description</label>
                    <textarea clrTextarea class="clr-col-12" name="customersettingdescription"
                      [rows]="4" [cols]="50" [(ngModel)]="item.description"></textarea>
                  </clr-textarea-container>
                  <clr-toggle-container>
                    <clr-toggle-wrapper>
                      <input type="checkbox" clrToggle [(ngModel)]="item.hidden"
                        name="customerenabled" />
                      <label>Hidden</label>
                    </clr-toggle-wrapper>
                  </clr-toggle-container>
                </div>
              </div>
            </form>

            <!-- <div class="edit-buttons">
              <button type="button" class="btn btn-outline-danger" (click)="deleteCustomerSetting(item)">
                <clr-icon shape="trash"></clr-icon> {{item.id == 0 ? 'Cancel' : 'Delete...'}}
              </button>
              <button type="button" class="btn btn-primary" (click)="saveCustomerSetting(item)">
                <clr-icon shape="floppy"></clr-icon> {{item.id == 0 ? 'Add' : 'Save'}}
              </button>
            </div> -->
          </div>
          <div class="clr-row">
            <div class="clr-col-6">

            </div>
            <div class="clr-col-6">
              <button type="button" class="btn btn-outline-danger" (click)="deleteCustomerSetting(item)">
                <clr-icon shape="trash"></clr-icon> {{item.id == 0 ? 'Cancel' : 'Delete...'}}
              </button>
              <button type="button" class="btn btn-primary" (click)="saveCustomerSetting(item)" [clrLoading]="saveState">
                <clr-icon shape="floppy"></clr-icon> {{item.id == 0 ? 'Add' : 'Save'}}
              </button>
            </div>
          </div>
        </div>
      </clr-dg-row-detail>
    </clr-dg-row>

    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="10">
        <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100,200]">Settings per page</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} settings
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>


<div *ngIf="!admin">
  <clr-datagrid *ngIf="customerSettings" #grid class="customer-settings-list" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'name'">
      <ng-container i18n='@@customersettings_name'>Name</ng-container>
    </clr-dg-column>
    <clr-dg-column>
      <ng-container i18n='@@customersettings_value'>Value</ng-container>
    </clr-dg-column>
    <clr-dg-column class="cell-edit-mode">
    </clr-dg-column>


    <clr-dg-row *clrDgItems="let item of customerSettings ; index as i" [clrDgItem]="item">
      <clr-dg-cell>{{item.name}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting != item && item.valueType == CustomerSettingsValueType.NUMERIC"> {{item.valueNumeric}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting != item && item.valueType == CustomerSettingsValueType.STRING"> {{item.valueString}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting != item && item.valueType == CustomerSettingsValueType.TIMESTAMP"> {{item.valueTimestamp}}</clr-dg-cell>
      <clr-dg-cell *ngIf="editCustomerSetting == item">
      <div class="edit-container">
        <div class="icons-edit-wrapper">
          <label class="edit-label">
              <clr-input-container class="edit-input" *ngIf="item.valueType == CustomerSettingsValueType.NUMERIC">
                <input clrInput placeholder="" class="edit-input" max="9999999" step="0.1" name="customersettingeditvaluenumeric" type="number" [(ngModel)]="editCustomerSetting.valueNumeric" />
              </clr-input-container>
              <clr-input-container class="edit-input" *ngIf="item.valueType == CustomerSettingsValueType.STRING">
                <input clrInput placeholder="" class="edit-input" max="9999999" name="customersettingeditvaluestring" type="text" size="30" [(ngModel)]="editCustomerSetting.valueString" />
              </clr-input-container>
              <clr-input-container class="edit-input" *ngIf="item.valueType == CustomerSettingsValueType.TIMESTAMP">
                <input clrInput placeholder="" class="edit-input" max="9999999" name="customersettingeditvaluetimestamp" type="date" size="30" [(ngModel)]="editCustomerSetting.valueTimestamp" />
              </clr-input-container>
              <cds-icon shape="times" size="md" class="edit-mode" (click)="cancelEditValue()"></cds-icon>
              <cds-icon shape="check" size="md" class="edit-mode" (click)="saveEditValue()"></cds-icon>
          </label>
        </div>
      </div>
      </clr-dg-cell>
      <clr-dg-cell class="cell-edit-mode">
        <cds-icon shape="pencil" size="sm" class="edit-mode" (click)="editValue(item)"></cds-icon>
      </clr-dg-cell>

      <clr-dg-row-detail *clrIfExpanded>
        <cds-icon shape="info-standard" size="sm"></cds-icon>
        <span class="item-description">{{item.description}}</span>
      </clr-dg-row-detail>
    </clr-dg-row>

    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="10">
        <clr-dg-page-size i18n='@@customersettings_settingsperpage' [clrPageSizeOptions]="[10,20,50,100,200]">Settings per page</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}}
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
